var $1a701756ef22cd1e$exports = {};
$1a701756ef22cd1e$exports = {
    "alert": `Melding`,
    "dismiss": `Negeren`
};


export {$1a701756ef22cd1e$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
